<template>
  <v-container class="pa-0">

    <auth
      :showRequired="!brain.oneTime && !auth.set"
      :showGuestContinue="showGuestContinue"
      v-on="$listeners"
      v-if="!auth.set"
    />

    <v-container
      fluid
      v-if="auth.set"
    >
      <div class="font-weight-bold d-flex align-center">
        Logged in as <offer-logout />
      </div>

      <payment-methods 
        @paymentMethod="setPaymentMethod"
      />

      <next
        v-on="$listeners"
        :disabled="!hasPaymentMethod"
      />
    </v-container>
  </v-container>
</template>

<script>
import Auth from '../../../../account/dialog/authenticate/Index'
import OfferLogout from '../../../../account/dialog/authenticate/OfferLogout'
import PaymentMethods from '../../../../stripe/PaymentMethods'
import Next from '../Next.vue'

export default {
  name: 'step_login',
  props: ['item', 'brain'],
  components: { Auth, OfferLogout, PaymentMethods, Next},
  data(){
    return {
      paymentMethod: null
    }
  },
  computed: {
    subscription(){return this.item.subscription || {}},
    showGuestContinue(){
      return this.brain.oneTime
        && !this.auth.set
    },
    hasPaymentMethod(){
      return this.paymentMethod
        && this.paymentMethod.id
    }
  },
  methods:{
    setPaymentMethod(v){
      this.paymentMethod = v
    }
  }
}
</script>